<template>
  <v-container fluid class="my-v-container">
    <v-app-bar app elevation="0" color="var(--bg-color)">
      <sea-plus-nav-icon></sea-plus-nav-icon>
      <v-spacer></v-spacer>
      <accumulate-nav-button></accumulate-nav-button>
    </v-app-bar>
    <v-card width="600" class="my-v-card">
      <v-card-title>サインイン</v-card-title>
      <v-card-subtitle>
        会員の方は、以下からサインインすることで、配送先ご住所やお支払い方法、プラン等のご変更可能です。
      </v-card-subtitle>
      <v-card-text>
        <v-row>
          <v-col>
            <v-btn color="primary" @click="signInWithGoogle" class="btn-sign-in">
              <img src="/ic_google@3x.png" />
              Googleでサインイン
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-btn color="primary" @click="signInWithEmail" class="btn-sign-in">
              <img src="/ic_email@3x.png" />
              Emailでサインイン
            </v-btn>
          </v-col>
        </v-row>
        <sign-up-message></sign-up-message>
        <terms-message></terms-message>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import { userCollection } from '@shared/collections/user.collection'
import SeaPlusNavIcon from '@/components/SeaPlusNavIcon.vue'
import AccumulateNavButton from '@/components/buttons/AccumulateNavButton.vue'
import { alertError } from '@/helpers/error'
import { firebase, firebaseAuth } from '@/services/firebase'
import SignUpMessage from '@/components/messages/SignUpMessage.vue'
import TermsMessage from '@/components/messages/TermsMessage.vue'

const userStore = createNamespacedHelpers('user')

export const saveUserAndRedirect = async ({ $this, userCredential }) => {
  const {
    user: { uid, displayName, email, phoneNumber, photoURL }
  } = userCredential
  const user = { id: uid, uid, displayName, email, phoneNumber, photoURL }

  // update database also
  const savedUser = await userCollection.find(user.id)
  $this.updateUser({
    ...(savedUser || {}),
    user
  })
  if (savedUser) {
    await userCollection.update(user.id)
  } else {
    await userCollection.update(user.id, {
      ...user,
      isNotificationEnabled: true,
      createdAt: new Date()
    })
  }

  if (savedUser && savedUser.plan) {
    $this.$router.replace('/')
  } else {
    const plan = $this.$route.query.plan
    if (plan) {
      $this.$router.replace(`/select-payment-method${getQueryParamsStringFromJson({ plan })}`)
    } else {
      $this.$router.replace(`/select-plan`)
    }
  }
}

export const getQueryParamsStringFromJson = (json) => {
  const arr = []
  Object.keys(json).map((key) => {
    const value = json[key]
    if (value !== undefined && value !== null) {
      arr.push(`${key}=${value}`)
    }
  })

  return arr.length > 0 ? `?${arr.join('&')}` : ''
}

export default {
  components: { SeaPlusNavIcon, AccumulateNavButton, SignUpMessage, TermsMessage },
  computed: {
    plan() {
      return this.$route.query.plan
    }
  },
  methods: {
    ...userStore.mapActions(['updateUser']),
    signInWithGoogle() {
      const provider = new firebase.auth.GoogleAuthProvider()
      provider.addScope('email')
      firebaseAuth.signInWithPopup(provider).then(
        (userCredential) => {
          console.log({ userCredential })
          saveUserAndRedirect({
            $this: this,
            userCredential
          })
        },
        (error) => {
          alertError(error)
        }
      )
    },
    signInWithEmail() {
      this.$router.replace(`/sign-in-with-email${getQueryParamsStringFromJson({ plan: this.plan })}`)
    }
  }
}
</script>

<style>
.my-v-card .v-btn.btn-sign-in img {
  width: 20px;
  height: 20px;
  position: absolute;
  left: 0px;
}
.my-v-card .v-btn.btn-sign-in .v-btn__content {
  text-transform: none;
  color: white;
  font-weight: normal;
  font-size: 1.2em;
}
</style>
